module.exports = __webpack_public_path__ + "static/annual-report-2011-12-96ea2aa87ef80216ce4520c3b016fb9f.pdf";